import React, { Component } from "react";
import parse, { domToReact } from "html-react-parser";

interface IChildComponentProps extends React.Props<any> {
    content: string;
    authData: any;
    title: string;
    handlePrint: any;
}

export class ComponentToPrint extends Component<IChildComponentProps, {}> {
    constructor(props: any) {
        super(props);
        this.state = {};
    }

    render() {
        const options = {
            replace: ({ attribs, children }: any) => {
                if (!attribs) return;

                if (attribs.hasOwnProperty("class")) {
                    if (attribs.class.indexOf("pdfPrint_icons") !== -1) {
                        return (
                            <a href="javascript:window.print();">
                                <i className="las la-print" style={{ fontSize: "32px", float: "right" }}></i>
                            </a>
                        );
                    }
                }

                if (attribs.hasOwnProperty("href")) {
                    if (attribs.href.indexOf("TermsAndConditions") !== -1 || attribs.href.indexOf("terms-of-use") !== -1)
                        return (
                            <a href="/terms" target="_blank">
                                {domToReact(children, options)}
                            </a>
                        );

                    if (
                        attribs.href.indexOf("privacy-policy") !== -1 ||
                        attribs.href.indexOf("canadian-privacy-policy") !== -1 ||
                        attribs.href.indexOf("PrivacyPolicy") !== -1
                    )
                        return (
                            <a href="/privacy" target="_blank">
                                {domToReact(children, options)}
                            </a>
                        );

                    if (
                        attribs.href.indexOf("EU-USPrivacyShield") !== -1 ||
                        attribs.href.indexOf("EUUSPrivacyShield") !== -1 ||
                        attribs.href.indexOf("privacy-shield-policy") !== -1
                    )
                        return (
                            <a href="/privacy-shield" target="_blank">
                                {domToReact(children, options)}
                            </a>
                        );

                    if (attribs.href.indexOf("ccpa-addendum") !== -1 || attribs.href.indexOf("CCPAAddendum") !== -1)
                        return (
                            <a href="/ccpa" target="_blank">
                                {domToReact(children, options)}
                            </a>
                        );

                    if (attribs.href.indexOf(window.location.hostname) === -1)
                        return (
                            <a href={attribs.href} target="_blank" rel="noreferrer">
                                {domToReact(children, options)}
                            </a>
                        );
                }
            },
        };

        return (
            <div className="box-content">
                {this.props.authData.isIDFUser && <h2>{this.props.title}</h2>}
                {!this.props.authData && this.props.authData.status !== "200" && <h2>{this.props.title}</h2>}
                {parse(this.props.content, options)}
            </div>
        );
    }
}
